import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7didlift8g: FaireBrandEntity = {
  token: "b_7didlift8g",
  type: "brand",
  name: "Tiepology",
  avatarUrl:
    "https://cdn.faire.com/fastly/b14c21e44fe5102414432394dbb56bf0835261d5ac02f43627dab8645b98c78f.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/e05c7ad4935d41236317d08b67d00bbe439cee7740ba413a0020c05ca2095292.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/b14c21e44fe5102414432394dbb56bf0835261d5ac02f43627dab8645b98c78f.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e05c7ad4935d41236317d08b67d00bbe439cee7740ba413a0020c05ca2095292.jpeg",
  location: "La Puente, CA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 325,
  isTopShop: true,
  isInsider: true,
  description:
    "Our company, Tiepology, is proud to supply high-quality and practicable products and is budget-friendly for many customers. Many customers continue to love our products due to the product quality, convenience, pleasure, and utility, providing the highest customer satisfaction. Our company's most important mission is focusing on customer satisfaction beyond our great products. \nWe began our venture by designing and selling handmade neckties and hair ties. Now, we are proud to announce that we have expanded our business to handle all hair accessories -\nwe project to control the design and production of our products. \nWe can be found at your local boutique shops nationwide. Tiepology's hopeful wish is to become a proud company for consumers to find joy and feel bliss when using our products.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:54:55.151Z",
    importedBy: "entity-db-cli",
  },
};
